import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const orientationModuleService = {
    show,
    store,
    update,
    updateStatus,
    updateSequence,
    destroy,
};

const MODULE = {
    ORIENTATION_MODULE: 'orientation-modules',
};

const API_URL = API.BASE_URL_API + '/v1';

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.ORIENTATION_MODULE}/${uuid}`);
}

export function store (data) {
    const formData = new FormData();
    formData.append(`header_uuid`, data.headerUuid);
    formData.append(`group_sequence`, data.groupSequence);
    formData.append(`module_name`, data.moduleName);
    formData.append(`module_sequence`, data.moduleSequence);

    if (data.groupUuid)
        formData.append(`group_uuid`, data.groupUuid);

    if (data.moduleImage && data.moduleImage instanceof File)
        formData.append('module_image', data.moduleImage);

    if (data.moduleScorm && data.moduleScorm instanceof File)
        formData.append('module_scorm', data.moduleScorm);

    return apiHelper(API_URL).post(`/${MODULE.ORIENTATION_MODULE}`, formData);
}

export function update (data) {
    const formData = new FormData();
    formData.append(`_method`, "put");

    formData.append(`group_uuid`, data.groupUuid);
    formData.append(`module_name`, data.moduleName);
    formData.append(`module_sequence`, data.moduleSequence);

    if (data.moduleImage && data.moduleImage instanceof File)
        formData.append(`module_image`, data.moduleImage);

    if (data.moduleScorm && data.moduleScorm instanceof File)
        formData.append(`module_scorm`, data.moduleScorm);
    
    return apiHelper(API_URL).post(`/${MODULE.ORIENTATION_MODULE}/${data.uuid}`, formData);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.ORIENTATION_MODULE}/${data.uuid}`, request);
}

export function updateSequence (data) {
    const request = {
        group_uuid: data.groupUuid,
    };

    if (data.modules.length) {
        request.modules = data.modules.map(item => ({
            uuid: item.uuid,
            sequence: item.sequence,
        }));
    }

    return apiHelper(API_URL).patch(`/${MODULE.ORIENTATION_MODULE}/sequences`, request);
}

export function destroy (uuid) {
    return apiHelper(API_URL).delete(`/${MODULE.ORIENTATION_MODULE}/${uuid}`);
}